import z from "zod";

const selectSchema = (field: string) =>
  z.object(
    {
      id: z.string(),
      name: z.string(),
    },
    { invalid_type_error: field },
  );

export const integrationRuleNotificationSchema = z.object({
  id: z.string().optional(),
  profile: selectSchema("O perfil é obrigatório"),
  typelNotification: selectSchema("O tipo de notificação é obrigatório"),
  channelNotification: selectSchema("O canal é obrigatório"),
  content: z.string().nullish(),
  emailCopyRecipients: z.string().nullish(),
});

export type TIntegrationRuleNotificationForm = z.infer<
  typeof integrationRuleNotificationSchema
>;
